/** @jsxImportSource ../../i18n */
import React from 'react';
import { Bar, BarChart, CartesianGrid, Cell, ReferenceLine, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';
import { usePrivacy } from '../../contexts/PrivacyContext';
import { usePrefersReducedMotion } from '../../theme/motion';
import { formatMoney } from '../../theme/format';
import { MASKED_AMOUNT } from '../ui/Money';
import { ChartTooltip } from './ChartTooltip';
import { axisProps, chartColors, gridProps } from './chartTheme';

export const PLBars = ({ data, height = 280, className }) => {
  const { hidden } = usePrivacy();
  const reduced = usePrefersReducedMotion();
  return (
    <div className={className} style={{ height }}>
      <ResponsiveContainer width="100%" height="100%">
        <BarChart data={data} layout="vertical" margin={{ top: 0, right: 8, bottom: 0, left: 0 }}>
          <CartesianGrid {...gridProps} vertical horizontal={false} />
          <XAxis type="number" {...axisProps} tickFormatter={(v) => (hidden ? '•••' : formatMoney(v, { compact: true }))} />
          <YAxis type="category" dataKey="name" {...axisProps} width={72} />
          <ReferenceLine x={0} stroke={chartColors.border} />
          <Tooltip cursor={{ fill: chartColors.grid, fillOpacity: 0.4 }} content={<ChartTooltip valueFormatter={(v) => (hidden ? MASKED_AMOUNT : formatMoney(v, { decimals: 0, sign: true }))} />} />
          <Bar dataKey="value" radius={[0, 4, 4, 0]} barSize={14} isAnimationActive={!reduced} animationDuration={700}>
            {data.map((entry) => <Cell key={entry.name} fill={entry.value >= 0 ? chartColors.gain : chartColors.loss} />)}
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export const MonthlyBars = ({ data, height = 200, className }) => {
  const { hidden } = usePrivacy();
  const reduced = usePrefersReducedMotion();
  return (
    <div className={className} style={{ height }}>
      <ResponsiveContainer width="100%" height="100%">
        <BarChart data={data} margin={{ top: 8, right: 0, bottom: 0, left: 0 }}>
          <CartesianGrid {...gridProps} />
          <XAxis dataKey="label" {...axisProps} tickMargin={8} interval={0} />
          <YAxis {...axisProps} width={52} tickFormatter={(v) => (hidden ? '•••' : formatMoney(v, { compact: true }))} />
          <Tooltip cursor={{ fill: chartColors.grid, fillOpacity: 0.4 }} content={<ChartTooltip valueFormatter={(v) => (hidden ? MASKED_AMOUNT : formatMoney(v))} />} />
          <Bar dataKey="value" fill={chartColors.gold} radius={[4, 4, 0, 0]} maxBarSize={28} isAnimationActive={!reduced} animationDuration={700} />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};
